import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {deleteTriumphpayauditRegistration} from 'App/api/integrations/typed';

const useDeleteTriumphpayauditRegistration = (
  mutationOptions?: UseMutationOptions<Awaited<ReturnType<typeof deleteTriumphpayauditRegistration>>, unknown, string>
) => {
  return useMutation<Awaited<ReturnType<typeof deleteTriumphpayauditRegistration>>, unknown, string>(
    async (tpaAlias) => await deleteTriumphpayauditRegistration(tpaAlias),
    {
      ...mutationOptions
    }
  );
};

export default useDeleteTriumphpayauditRegistration;
